import {
  buildPdfCategoryHeaderRow,
  computeLineDisplayAmount,
  formatInvoicePdfLineEntry,
  PDF_LINE_INDENT,
} from "./formatInvoicePdfLine";

function normalizedLabel(value) {
  return String(value ?? "").trim().toLowerCase();
}

function shouldRenderGroupAsHeaderAmount(group) {
  if ((group.lines ?? []).length !== 1) {
    return false;
  }
  const line = group.lines[0];
  const postageRollup = Number(line.pdfRollupAmount);
  if (Number.isFinite(postageRollup) && postageRollup > 0) {
    return true;
  }
  const servicesRendered = String(group.servicesRendered ?? "").trim();
  const description = String(line.description ?? "").trim();
  if (!servicesRendered || !description) {
    return false;
  }
  return normalizedLabel(servicesRendered) === normalizedLabel(description);
}

/**
 * Build PDF line segments in mapped line order (already profile-sorted).
 * Consecutive lines with the same servicesRendered stay in one group.
 */
export function buildInvoicePdfLineTree(mappedLines) {
  const segments = [];

  for (const line of mappedLines ?? []) {
    const servicesRendered = String(line.profileDetail?.servicesRendered ?? "").trim();
    if (!servicesRendered) {
      segments.push({ type: "line", line });
      continue;
    }

    const key = servicesRendered.toLowerCase();
    const last = segments[segments.length - 1];
    if (last?.type === "group" && last.key === key) {
      last.lines.push(line);
      continue;
    }

    segments.push({
      type: "group",
      key,
      servicesRendered,
      lines: [line],
    });
  }

  return { segments };
}

export function buildInvoicePdfLineTreeContent(lineTree) {
  const content = [];

  for (const segment of lineTree?.segments ?? []) {
    if (segment.type === "line") {
      content.push(formatInvoicePdfLineEntry(segment.line, segment.line.profileDetail, 0));
      continue;
    }

    const group = {
      servicesRendered: segment.servicesRendered,
      lines: segment.lines ?? [],
    };

    if (shouldRenderGroupAsHeaderAmount(group)) {
      const line = group.lines[0];
      content.push(
        buildPdfCategoryHeaderRow(
          group.servicesRendered,
          computeLineDisplayAmount(line, line.profileDetail)
        )
      );
      continue;
    }

    content.push({
      text: group.servicesRendered,
      bold: true,
      margin: [0, 8, 0, 2],
    });

    for (const line of group.lines) {
      content.push(formatInvoicePdfLineEntry(line, line.profileDetail, PDF_LINE_INDENT));
    }
  }

  return content;
}
